<div class="full-height d-flex fd-col overflow-y-auto custom-scrollbar" tabindex="0">
  <p class="work-sans-font text-size-14 line-height-2 m-1 text-white">
    Permite consultar la información de los agentes cada minuto y su actividad las últimas 8 horas. Haga clic en un punto sobre el mapa para consultar la información.
  </p>

  <div
    class="d-flex fd-row bg-color-background-1 align-items-center border-md-top-right-25 border-md-top-left-25 pt-md-15 mt-1 mb-12">
    <div class="left-title-block bg-color-primary-1"></div>
    <sit-icon [icon]="Icon.active_agent" [sizeClass]="'icon-size-24'" class="mr-1 ml-16"
      alt="silbato agente icono título indicadores"></sit-icon>
    <h3 class="text-color-secondary-2 m-0 text-size-18 text-weight-500">
      GENERAL
    </h3>
  </div>
  <div class="d-flex fd-row justify-space-around align-items-center">
    <div class="d-flex fd-col justify-center align-items-center text-white">
      <sit-icon [icon]="Icon.active_agent_green" [sizeClass]="'icon-size-78'" class="mr-1 ml-16"
        alt="silbato agente icono para total agentes"></sit-icon>
      <span>{{ totalAgents }}</span>
      <label>Total Agentes</label>
    </div>
    <div class="d-flex fd-col justify-center align-items-center text-white">
      <sit-icon [icon]="Icon.police_agent" [sizeClass]="'icon-size-78'" class="mr-1 ml-16"
        alt="gorra agente icono para total policías de tránsito"></sit-icon>
      <span>{{ totalPoliceAgents }}</span>
      <label>Total Policía de Tránsito</label>
    </div>
    <div class="d-flex fd-col justify-center align-items-center text-white">
      <sit-icon [icon]="Icon.transit_agent" [sizeClass]="'icon-size-78'" class="mr-1 ml-16"
        alt="gorra agente icono para total agentes de tránsito"></sit-icon>
      <span>{{ totalTransitAgents }}</span>
      <label>Total Agentes de Tránsito</label>
    </div>
  </div>

  <div
    class="d-flex fd-row bg-color-background-1 align-items-center border-md-top-right-25 border-md-top-left-25 pt-md-15 mt-1 mb-12">
    <div class="left-title-block bg-color-primary-1"></div>
    <sit-icon [icon]="Icon.last_hours_w" [sizeClass]="'icon-size-24'" class="mr-1 ml-16"
      alt="reloj icono título gráfica historico de agentes"></sit-icon>
    <h3 class="text-color-secondary-2 m-0 text-size-18 text-weight-500">
      AGENTES
    </h3>
  </div>
  <div class="d-flex fd-row chart-line-container">
    <sit-chart-line [properties]="dataGraphicList" [colorScale]="colorScale" class="full-width">
    </sit-chart-line>
  </div>
  <div
    class="d-flex fd-row bg-color-background-1 align-items-center border-md-top-right-25 border-md-top-left-25 pt-md-15 mt-1 mb-12">
    <div class="left-title-block bg-color-primary-1"></div>
    <sit-icon [icon]="Icon.agents_w" [sizeClass]="'icon-size-24'" class="mr-1 ml-16"
      alt="gorra agentes icono título lista de agentes"></sit-icon>
    <h3 class="text-color-secondary-2 m-0 text-size-18 text-weight-500">
      TOTAL REGISTRO DE AGENTES
    </h3>
  </div>
  <div>
    <table class="table-agents">
      <thead class="text-white text-size-12">
        <th>ID Agente</th>
        <th>Nombre del Agente</th>
        <th>Última Conexión</th>
      </thead>
      <tbody class="p-0 text-weight-400 work-sans-font text-size-16 text-white">
        <ng-container *ngFor="let item of cards">
          <tr (click)="openModal(item)">
            <td>{{ item.id }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.updatedDate | date: 'dd/MM/yyyy - HH:mm' }}</td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>
